export default "/assets/images/shushing-face.png?6ad4e8f7c031580dc548b64e711e0743";